export default function getBytescaleImageURL(path, width, height) {
  // cache_perm=auto: permanent cache only if processing >500ms, cache_ttl=1year for edge cache
  return `https://upcdn.io/${process.env.REACT_APP_BYTESCALE_ACCOUNT_ID}/image${path}?w=${width}&h=${height}&f=auto&cache_perm=auto&cache_ttl=31536000`;
}

export function getBytescaleVideoURL(path) {
  // Use /video endpoint to get processing job response
  // The BytescaleVideo component will fetch this and extract the artifact URL
  return `https://upcdn.io/${process.env.REACT_APP_BYTESCALE_ACCOUNT_ID}/video${path}?h=1080&f=mp4-h264`;
}

/**
 * Gets the initial Bytescale video URL for server-side rendering
 * This returns the raw URL immediately without async processing
 */
export function getBytescaleVideoURLSync(path) {
  // For SSR/initial render, use raw URL
  return `https://upcdn.io/${process.env.REACT_APP_BYTESCALE_ACCOUNT_ID}/raw${path}`;
}
